import React from 'react'
import Header from '../Menpages/Header/Main'

import Bredcom from '../MenTeam/Bredcom'
import PremiumCheckForm from '../Menpages/pay-premium/main'
// import Header from '../Menhome/Header'
import Footer from '../Menhome/Footer'


function Paypremium() {
  return (
    <>
        <div className="page-wrapper">
            {/* <Header/> */}
            <Header/>
            <Bredcom title={"Insurances"} head={"Pay Premium"} sbtitle={"Pay Premium"}/>
            <PremiumCheckForm/> 
            <Footer/>
        </div>
    </>
  )
}

export default Paypremium;